import { render, staticRenderFns } from "./LicensePermissionsWidget.vue?vue&type=template&id=233cc130&lang=pug"
import script from "./LicensePermissionsWidget.vue?vue&type=script&lang=js"
export * from "./LicensePermissionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports